export enum AuthorityPlanAccount {
  REGISTER_PLAN_ACCOUNT_VIEW_FINANCIAL_RESTRICTION = '1.11.6',
  REGISTER_PLAN_ACCOUNT_REPORTS = '1.11.5',
  REGISTER_PLAN_ACCOUNT_EDIT = '1.11.4',
  REGISTER_PLAN_ACCOUNT_DELETE = '1.11.3',
  REGISTER_PLAN_ACCOUNT_ADD = '1.11.2',
  REGISTER_PLAN_ACCOUNT_VIEW = '1.11.1',
  REGISTER_PLAN_ACCOUNT_REGISTRATION = '1.11',

  DEFAULT_PLAN_ACCOUNT_PROFILE_READ = '1.11.7',
  DEFAULT_PLAN_ACCOUNT_PROFILE_CREATE = '1.11.8',
  DEFAULT_PLAN_ACCOUNT_PROFILE_UPDATE = '1.11.9',
  DEFAULT_PLAN_ACCOUNT_PROFILE_DELETE = '1.11.10',
}
